//Componentes generales
import { useContext, useEffect } from "react";
import { Route, Routes } from "react-router-dom";

//Views
import Login from "../../views/login/Login";
import Home from "../../views/home/Home";
import User from "../../views/user/User";
import Product from "../../views/product/Product";
import ReqSector from "../../views/reqSector/ReqSector";
import Warehouse from "../../views/warehouse/Warehouse";
import SharedLayout from "../../components/sharedLayout/SharedLayout";
import AddReq from "../../views/addReq/AddReq";
import Grupos from "../../views/Grupos/Grupos";
import Sucuenta from "../../views/Subcuenta/Subcuenta"
import GlobalSettings from "../../views/globalSettings/GlobalSettings"
import Reportes from "../../views/reportes/Reportes"

//Rutas
import Routes_gral from "../Routes_gral";

import authContext from "../../context/authentication/authContex";

//Token
import tokenAuth from "../../config/token";
import Subcuenta from "../../views/Subcuenta/Subcuenta";

// Revisar si tenemos un token
const token = localStorage.getItem("token");

if (token) {
  tokenAuth(token);
}

function Rutas() {
  //Context de Autenticacion
  const aContext = useContext(authContext);
  const { usuarioAutenticado } = aContext;

  useEffect(() => {
    usuarioAutenticado();
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path={Routes_gral.login} element={<Login />} />
        <Route
          path={Routes_gral.group}
          element={
            <SharedLayout section={"Grupos"}>
              {" "}
              <Grupos />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.home}
          element={
            <SharedLayout section={"Home"}>
              {" "}
              <Home />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.addReq}
          element={
            <SharedLayout section={"Nuevo Requerimiento"}>
              {" "}
              <AddReq edicion={false} />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.user}
          element={
            <SharedLayout section={"Usuarios"}>
              {" "}
              <User />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.product}
          element={
            <SharedLayout section={"Productos"}>
              {" "}
              <Product />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.reqSector}
          element={
            <SharedLayout section={"Sectores de Requerimientos"}>
              {" "}
              <ReqSector />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.subcuentas}
          element={
            <SharedLayout section={"Subcuentas"}>
              {" "}
              <Subcuenta />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.globalSettings}
          element={
            <SharedLayout section={"Configuracion Global"}>
              {" "}
              <GlobalSettings />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.warehouse}
          element={
            <SharedLayout section={"Depósitos"}>
              {" "}
              <Warehouse />{" "}
            </SharedLayout>
          }
        />
        <Route
          path={Routes_gral.reportes}
          element={
            <SharedLayout section={"Reportes"}>
              {" "}
              <Reportes />{" "}
            </SharedLayout>
          }
        />
      </Routes>
    </div>
  );
}

export default Rutas;